import {Button, Box, Typography} from "@mui/material";
import React from "react";
import * as PropTypes from "prop-types";
import {ProvidersService} from "../../services/ProvidersService";
import {ServiceEditorForm} from "../../components/profileEditors/ServiceEditorForm";


export class ServicesProvidedTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSaving: false,
            isRemoving: false,
        }
    }

    async onSaveButtonClick(e) {
        this.props.clearAutoSave();
        this.setState({ isSaving: true });
        try {
            await ProvidersService.updateProvider(this.props.provider);
            this.props.setAddNew(false);
        } finally {
            this.setState({ isSaving: false });
        }
    }

    async onRemoveButtonClick(e) {
        this.setState({ isRemoving: true });
        try {
            await this.props.removeService(this.props.selectedServiceIndex);
        } finally {
            this.setState({ isRemoving: false });
        }
    }

    render() {
        return <Box sx={{ p: '5px', pb: '25px' }} key={"servicesProvidedTab"}>

            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>Services</Typography>

            <ServiceEditorForm
                provider={this.props.provider}
                setProvider={this.props.setProvider}
                selectedServiceIndex={this.props.selectedServiceIndex}
                addNew={this.props.addNew}
            />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px' }}>
                {!this.props.addNew && (
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={this.onRemoveButtonClick.bind(this)}
                        disabled={this.state.isRemoving || this.state.isSaving}
                    >
                        {this.state.isRemoving ? 'Removing…' : 'Remove Service'}
                    </Button>
                )}
                <Button
                    variant="contained"
                    onClick={this.onSaveButtonClick.bind(this)}
                    disabled={this.state.isSaving || this.state.isRemoving}
                    sx={{ marginLeft: 'auto' }}
                >
                    {this.state.isSaving ? 'Saving…' : 'Save Service'}
                </Button>
            </Box>

        </Box>;
    }
}

const servicePropType = PropTypes.shape({
    category: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    offeredLengths: PropTypes.arrayOf(
        PropTypes.shape({
            length: PropTypes.number.isRequired,
            price: PropTypes.number.isRequired,
        })
    ),
    description: PropTypes.string.isRequired,
});

const providerPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    categoryType: PropTypes.string.isRequired,
    servicesProvided: PropTypes.arrayOf(servicePropType).isRequired,
    phoneNumber: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    businessSummary: PropTypes.string.isRequired,
    carouselImages: PropTypes.arrayOf(PropTypes.string).isRequired,
    imageList: PropTypes.arrayOf(PropTypes.string).isRequired,
    etag: PropTypes.string.isRequired,
});

ServicesProvidedTab.propTypes = {
    provider: providerPropType.isRequired,
    setProvider: PropTypes.func.isRequired,
    refreshProvider: PropTypes.func.isRequired,
    buttonStyle: PropTypes.any.isRequired,
    selectedServiceIndex: PropTypes.number.isRequired,
    addNew: PropTypes.bool,
    setAddNew: PropTypes.func.isRequired,
    removeService: PropTypes.func.isRequired,
    clearAutoSave: PropTypes.func.isRequired
};

